export default "__VITE_ASSET__Balb4GxG__"